import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Field, getFormValues } from "redux-form";

import { ReduxControls, Button, ProgressIndicator } from "rhombus-react";

import { loadSharableLinks } from "reducers/CreativePreviews";
import { closeModal } from "reducers/Modal";

import BasicModal from "widgets/modals/BasicModal";
import LinkTable from "widgets/modals/creatives/preview/sharing/LinkTable";
import CopyLinksButton from "widgets/modals/creatives/preview/sharing/CopyLinksButton";
import { SHARE_CREATIVE_PREVIEWS_FORM } from "widgets/modals/creatives/preview/sharing/utils";

export default function ShareSingleModal(props){
	const dispatch = useDispatch();

	const {
		creativeIds,
		useVersionLinks,
	} = props;
	const {
		sharableLinks = [],
		isLoadingSharableLinks,
	} = useSelector(state => state.creativePreviews);
	const { id: libraryId } = useSelector(state => state.libraryProperties || {});

	const values = useSelector(getFormValues(SHARE_CREATIVE_PREVIEWS_FORM));
	const { isPermanent } = values || {};

	useEffect(() => {
		dispatch(loadSharableLinks(libraryId, creativeIds, null, isPermanent));
	}, [creativeIds, isPermanent]);

	function onClose(){
		dispatch(closeModal());
	}

	const modalProps = {
		title: useVersionLinks ? "Share Versions" : "Share Creatives",
		className: "share-creative-previews-modal basic-modal",
		onClose,
		renderContent(){
			return (
				<div className="progress-container">
					<ProgressIndicator isLoading={isLoadingSharableLinks} />
					<div className="fields">
						<Field
							name = "isPermanent"
							label = "Make links permanent (regular links expire after 90 days)"
							component = {ReduxControls.Checkbox}
							useValue
						/>
					</div>
					<p>These public preview links are now available and can be viewed by anyone you share the URL with:</p>
					<LinkTable
						links={sharableLinks}
						useVersionLinks={useVersionLinks}
					/>
				</div>
			);
		},
		renderFooter(){
			return (
				<>
					<Button
						onClick = {onClose}
						theme = "default"
					>
						Close
					</Button>
					<CopyLinksButton />
				</>
			);
		},
	};

	return <BasicModal {...modalProps} />;
}

ShareSingleModal.displayName = "ShareSingleModal";
ShareSingleModal.defaultProps = {
	creativeIds: [],
	useVersionLinks: false,
};
